<template>
  <div class="box">
    <div class="box-body text-left mt-3">
      <iframe
        class="video-iframe"
        :src="videoURL"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<style scoped>
.video-iframe {
  width: 100%;
  min-height: 700px;
}
</style>

<script>
export default {
  name: "ad-view",
  data() {
    return {
      adsList: [
        "https://www.youtube.com/embed/T5KKfdAcmyw?autoplay=1",
        "https://www.youtube.com/embed/eOMhOjgNd7Q?autoplay=1",
        "https://www.youtube.com/embed/cGBbsh_bEng?autoplay=1",
        "https://www.youtube.com/embed/H6AyjzX-upA?autoplay=1",
        "https://www.youtube.com/embed/iMQ_e1cvPjE?autoplay=1",
        "https://www.youtube.com/embed/LyZAYqIYJO0?autoplay=1",
        "https://www.youtube.com/embed/c6v16RsYOCE?autoplay=1",
        "https://www.youtube.com/embed/9rx7-ec0p0A?autoplay=1",
        "https://www.youtube.com/embed/flh4LOyNWmE?autoplay=1",
        "https://www.youtube.com/embed/cSf9YSr0jFo?autoplay=1",
        "https://www.youtube.com/embed/UZiDpGTWNFY?autoplay=1",
        "https://www.youtube.com/embed/yyAdRptgUiI?autoplay=1",
        "https://www.youtube.com/embed/98FeuV-NqWc?autoplay=1",
        "https://www.youtube.com/embed/mHrPXJ5Eo7A?autoplay=1",
        "https://www.youtube.com/embed/zD7LEWT935U?autoplay=1",
        "https://www.youtube.com/embed/YgqBKFTkGJQ?autoplay=1",
        "https://www.youtube.com/embed/UqRWf8p6i_A?autoplay=1",
        "https://www.youtube.com/embed/Os7Lnxr1Ric?autoplay=1",
        "https://www.youtube.com/embed/KjiXn9v8BPM?autoplay=1",
        "https://www.youtube.com/embed/jH_5UBqBNbM?autoplay=1",
        "https://www.youtube.com/embed/PZOxHrRUs8I?autoplay=1",
        "https://www.youtube.com/embed/Pk6K_5Ata3I?autoplay=1",
        "https://www.youtube.com/embed/lpIFJaEKfB4?autoplay=1",
        "https://www.youtube.com/embed/Jg_oEyJ-1qg?autoplay=1",
        "https://www.youtube.com/embed/GZgwpaENFKQ?autoplay=1",
        "https://www.youtube.com/embed/Y-olifQWx5w?autoplay=1",
        "https://www.youtube.com/embed/H4ytfQxQmSo?autoplay=1",
        "https://www.youtube.com/embed/3e_QXiVoNN0?autoplay=1",
        "https://www.youtube.com/embed/4W9DuEfkWAo?autoplay=1",
        "https://www.youtube.com/embed/SjcdtyNPjrM?autoplay=1",
        "https://www.youtube.com/embed/ej3ZCgMcIEc?autoplay=1",
        "https://www.youtube.com/embed/Vgaurn7ACUU?autoplay=1",
        "https://www.youtube.com/embed/Yx844165Mpo?autoplay=1",
        "https://www.youtube.com/embed/m-FPJ_QECjk?autoplay=1",
        "https://www.youtube.com/embed/Mn6aUDqT6AI?autoplay=1",
        "https://www.youtube.com/embed/RPMDEVfXpaY?autoplay=1",
        "https://www.youtube.com/embed/k8xjuxV1U6Y?autoplay=1",
        "https://www.youtube.com/embed/gFaQwIw5DNg?autoplay=1",
        "https://www.youtube.com/embed/rtplTIVZjGE?autoplay=1",
        "https://www.youtube.com/embed/aQymPwrfIA4?autoplay=1",
        "https://www.youtube.com/embed/V_ozu_7Xweg?autoplay=1",
        "https://www.youtube.com/embed/Iub18FUnm_0?autoplay=1",
        "https://www.youtube.com/embed/dwu5QNTmfBE?autoplay=1",
        "https://www.youtube.com/embed/NXeH7oU9SIo?autoplay=1",
        "https://www.youtube.com/embed/1Kr_5DfOwlU?autoplay=1",
        "https://www.youtube.com/embed/hCBVXfIbvPk?autoplay=1",
        "https://www.youtube.com/embed/ThNvbdBbKeo?autoplay=1",
        "https://www.youtube.com/embed/turMRRCE6fU?autoplay=1",
        "https://www.youtube.com/embed/42q8o45nBvk?autoplay=1",
        "https://www.youtube.com/embed/M0xNAtSwz_I?autoplay=1",
        "https://www.youtube.com/embed/qL5mbCqxmGI?autoplay=1",
        "https://www.youtube.com/embed/2tW7ZVE2sDw?autoplay=1",
        "https://www.youtube.com/embed/1g7pPo4CnoU?autoplay=1",
        "https://www.youtube.com/embed/fUd9YPUx9BA?autoplay=1",
        "https://www.youtube.com/embed/aWmLfMJXC5E?autoplay=1",
        "https://www.youtube.com/embed/zk2m5Nhcwos?autoplay=1",
        "https://www.youtube.com/embed/0beNwxtNsYw?autoplay=1"
      ]
    };
  },
  computed: {
    videoURL() {
      return this.adsList[Math.floor(Math.random() * this.adsList.length)];
    }
  }
};
</script>
